export default __webpack_public_path__ + "fonts/bank-owned.svg";